import { useEffect, useRef } from "react";
import { toast } from "sonner";
import { useReminderMutations, useReminders } from "@/hooks/useReminders";
import { t } from "@shared/i18n";

/**
 * Sonnerie à l'heure exacte tant que l'application est ouverte (le serveur envoie aussi une notification
 * et, si demandé, un e-mail, même application fermée).
 */
export function ReminderAlarms() {
  const { data } = useReminders({ refetchInterval: 5 * 60_000 });
  const { update, snooze } = useReminderMutations();
  const timers = useRef(new Map<string, ReturnType<typeof setTimeout>>());
  const rang = useRef(new Set<string>());

  useEffect(() => {
    const map = timers.current;
    for (const t of map.values()) clearTimeout(t);
    map.clear();
    for (const r of data ?? []) {
      if (r.doneAt) continue;
      const key = `${r.id}:${r.remindAt}`;
      const delay = new Date(r.remindAt).getTime() - Date.now();
      if (rang.current.has(key) || delay > 15 * 60_000 || delay < -60_000) continue;
      map.set(
        key,
        setTimeout(() => {
          rang.current.add(key);
          try {
            if ("Notification" in window && Notification.permission === "granted") new Notification(t("Rappel GBC Coach IA"), { body: r.text, icon: "/icons/icon-192.png", tag: key });
          } catch {
            /* notifications système indisponibles */
          }
          if ("vibrate" in navigator) navigator.vibrate?.([120, 80, 120]);
          toast(`⏰ ${r.text}`, {
            duration: 60_000,
            action: { label: t("C'est fait"), onClick: () => update.mutate({ id: r.id, done: true }) },
            cancel: { label: t("Dans 10 min"), onClick: () => snooze.mutate({ id: r.id, minutes: 10 }) },
          });
        }, Math.max(0, delay)),
      );
    }
    return () => {
      for (const t of map.values()) clearTimeout(t);
    };
  }, [data, update, snooze]);
  return null;
}
